<div class="auth-wrapper">
  <div class="auth-card">

    <!-- Logo -->
    <div class="logo">
      <img src="assets/logo.png" alt="Logo">
    </div>

    <!-- LOGIN FORM -->
    <form *ngIf="!showRegister" [formGroup]="loginForm" class="form">

      <h2 class="title">Welcome Back</h2>
      <p class="subtitle">Login to your account</p>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>

      <button mat-raised-button color="primary" class="auth-btn" (click)="login()">
        Login
      </button>

      <p class="switch-text">
        Don’t have an account?
        <span (click)="showRegister = true">Register</span>
      </p>

    </form>

    <!-- REGISTER FORM -->
    <form *ngIf="showRegister" [formGroup]="registerForm" class="form">

      <h2 class="title">Create Account</h2>
      <p class="subtitle">Register to get started</p>

      <mat-form-field appearance="outline">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Email</mat-label>
        <input matInput formControlName="email">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Phone</mat-label>
        <input matInput formControlName="phone">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password">
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Confirm Password</mat-label>
        <input matInput type="password" formControlName="confirmPassword">
      </mat-form-field>

      <button mat-raised-button color="primary" class="auth-btn" (click)="register()">
        Register
      </button>

      <p class="switch-text">
        Already have an account?
        <span (click)="showRegister = false">Back to Login</span>
      </p>

    </form>

  </div>
</div>
